<template>
  <div class="overview-item">
    <div class="num">{{num}}</div>
    <div class="label">{{label}}</div>
    <div class="unit">（{{unit}}）</div>
  </div>
</template>

<script>
export default {
  props:{
    num:Number,
    unit:String,
    label:String
  }
}
</script>

<style lang="scss" scoped>
.overview-item{
  display: flex;
  width: 123px;
  height: 94px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url('~@/assets/images/挂牌项目.png') center center / cover no-repeat;
  .num{
    font-weight: bold;
    color:var(--color);
    margin-bottom: 10px;
    font-size: 20px;
  }
  .label{
    margin-bottom: 4px;
  }
  .label,.unit{
    color: #fff;
    font-size: 14px;
  }
}
</style>